import { actionType, aclType, layoutItemActionType, sectionLayoutActionType } from './enums';

function createFieldAction(action) {
  return {
    id: action.portal_field_id,
    field_id: action.field_id,
    acl_action: '',
    filter_values: [],
    select_values: [],
    set_date: null,
    __typename: 'FieldAction'
  };
}

function createSectionAction(acl) {
  return {
    id: acl.portal_category_id,
    section_id: acl.section_id,
    acl_action: '',
    __typename: 'SectionAction'
  };
}
function applyFilterValuesListAction(applicableActions, action) {
  let fieldAction = applicableActions.fieldActions.find(fieldAcn => fieldAcn.id === action.portal_field_id);
  if (!fieldAction) {
    fieldAction = createFieldAction(action);
    fieldAction.filter_values = action.values;
    applicableActions.fieldActions.push(fieldAction);
  } else {
    fieldAction.filter_values = action.values;
  }
}

function sortAndGetValuesForValuesList(applicableActions) {
  applicableActions.fieldActions.forEach(fieldAction => {
    if (fieldAction.filter_values.length > 0) {
      fieldAction.filter_values.sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1));
      // eslint-disable-next-line no-param-reassign
      fieldAction.filter_values = fieldAction.filter_values.map(filter_value => filter_value.value);
    }
    if (fieldAction.select_values.length > 0) {
      fieldAction.select_values.sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1));
      // eslint-disable-next-line no-param-reassign
      fieldAction.select_values = fieldAction.select_values.map(select_value => select_value.value);
    }
  });
}

function applyConditionalLayout(applicableActions, action) {
  let sectionAction;
  let fieldAction;
  if (action.aclList != null && action.aclList.length > 0) {
    action.aclList.forEach(acl => {
      switch (acl.acl_type) {
        case aclType.Section:
          sectionAction = applicableActions.sectionActions.find(act => act.id === acl.portal_category_id);
          if (!sectionAction) {
            sectionAction = createSectionAction(acl);
            sectionAction.acl_action = acl.section_layout_action_type;
            applicableActions.sectionActions.push(sectionAction);
            // Following conditions are for conflict resolution for ACL section
          } else if (acl.section_layout_action_type === sectionLayoutActionType.ReadOnly) {
            sectionAction.acl_action = acl.section_layout_action_type;
          } else if (acl.section_layout_action_type === sectionLayoutActionType.ForceDisplay) {
            if (sectionAction.acl_action === sectionLayoutActionType.Hide || sectionAction.acl_action === sectionLayoutActionType.Display) {
              sectionAction.acl_action = acl.section_layout_action_type;
            }
          } else if (acl.section_layout_action_type === sectionLayoutActionType.Hide) {
            if (sectionAction.acl_action === sectionLayoutActionType.Display) {
              sectionAction.acl_action = acl.section_layout_action_type;
            }
          }
          break;
        case aclType.LayoutItem:
          fieldAction = applicableActions.fieldActions.find(act => act.id === acl.portal_field_id);
          if (!fieldAction) {
            fieldAction = createFieldAction(acl);
            fieldAction.acl_action = acl.layout_action_type;
            applicableActions.fieldActions.push(fieldAction);
          }
          // if field action has value due to filter VL, Set Date or set VL
          if (fieldAction.acl_action === '') {
            fieldAction.acl_action = acl.layout_action_type;
            // Following conditions are for conflict resolution for ACL Field
          } else if (acl.layout_action_type === layoutItemActionType.Required) {
            fieldAction.acl_action = acl.layout_action_type;
          } else if (acl.layout_action_type === layoutItemActionType.ReadOnly) {
            if (
              fieldAction.acl_action === layoutItemActionType.ForceDisplay ||
              fieldAction.acl_action === layoutItemActionType.Display ||
              fieldAction.acl_action === layoutItemActionType.Hide
            ) {
              fieldAction.acl_action = acl.layout_action_type;
            }
          } else if (acl.layout_action_type === layoutItemActionType.ForceDisplay) {
            if (fieldAction.acl_action === layoutItemActionType.Hide || fieldAction.acl_action === layoutItemActionType.Display) {
              fieldAction.acl_action = acl.layout_action_type;
            }
          } else if (acl.layout_action_type === layoutItemActionType.Hide) {
            if (fieldAction.acl_action === layoutItemActionType.Display) {
              fieldAction.acl_action = acl.layout_action_type;
            }
          }
          break;
        default:
          break;
      }
    });
  }
}

export function populateApplicableActions(actions, filterCriteriaFieldIds) {
  const applicableActions = {
    invokeActionsForFields: filterCriteriaFieldIds,
    sectionActions: [],
    fieldActions: []
  };
  actions.forEach(action => {
    switch (action.action_type) {
      case actionType.ApplyConditionalLayout: {
        applyConditionalLayout(applicableActions, action);
        break;
      }
      case actionType.FilterValuesList: {
        applyFilterValuesListAction(applicableActions, action);
        break;
      }
      case actionType.SetValuesList:
        break;
      case actionType.SetDate:
        break;
      default:
        throw new Error(`Encountered an unknown action type "${action.action_type}".`);
    }
  });
  sortAndGetValuesForValuesList(applicableActions);
  return applicableActions;
}

export default populateApplicableActions;
